import { render, staticRenderFns } from "./LongDescription.vue?vue&type=template&id=1c18bcfb&scoped=true&lang=pug"
import script from "./LongDescription.vue?vue&type=script&lang=js"
export * from "./LongDescription.vue?vue&type=script&lang=js"
import style0 from "./LongDescription.vue?vue&type=style&index=0&id=1c18bcfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c18bcfb",
  null
  
)

export default component.exports